export enum zIndex {
    mobileNavigation = 30,
    overlay = 20,
    popoverMenu = 5,
    stickyHeader = 15,
    stickyTableHeader = 2,
}
